
<div style="position:relative; z-index: 100; width: 100%;    ">
<nav class="navbar navbar-expand-md fixed-top py-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid lozad" src="assets/img/logo.png"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
      

         <li class="nav-item">
    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

 
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/home/index.html"
      >Hub</a
    >
  </li>

         <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
      </ul>
    </div>
  </div>
</nav>
</div>

<!------- tab section end ---------->

<section id="acc" style="margin-top: 200px;">
  <div class="container my-5">
    <h2 class="text-center">
      Membership / Business / I AM Pledge Card Features
    </h2>
    <div class="row">
      <!-- <div class="col-md-3"></div> -->
      <div class="col-md-6">
        <ul>
          <li>Cover Image</li>
          <li>About Us</li>
          <li>VPN Webinar</li>
          <li>Social: FB, Twitter, LinkedIn, You tube, Instagram, Pinterest</li>
          <li>Communication</li>
          <li>Skype ID</li>
          <li>Whats App</li>
          <li>Snapchat</li>
          <li>Videos</li>
          <li>Scheduling</li>
          <li>Link Button to website</li>
          <li>Live Chats</li>
          <li>Follow My Card</li>
          <li>Save My Contacts</li>
          <li>Friend Request</li>
          <li>Audio/Images</li>
          <li>Search Biz Card, Friends, Photo & Video</li>
          <li>Library of Card Templates to Choose From</li>
          <li>Social Networking platform (Backend)</li>
          <li>➔ QR Code</li>
          <li>Add My Logo</li>
          <li>Upgrade</li>
          <li>Share My Card</li>
          <li>Save Customer Information</li>
          <li>See how many times the card was shared and viewed.</li>
        </ul>
      </div>
      <div class="col-md-6 mt-4">
        <object data="assets/umyonetwrok.pdf" class="w-100 h-100"></object>
      </div>
    </div>
  </div>
</section>
<!-- Featurs Section End -->

<footer>
  <div class="container">
    <h3>Own Your Platform. Build Your Future. UMYO LGBTQ+ Community.</h3>
    <h6>This is more than just a safe space—it's a transformative hub where identity is celebrated, voices are amplified, and connection fuels growth.</h6>
  </div>
</footer>
